<template>
    <div>
        <button class="form-contol btn btn-primary" v-on:click="$refs['undertakingModal'].open()">Assign An Undertaking</button>
        <div class="alert alert-success" v-if="assignedUndertaking">
            Undertaking Assigned: <span class="badge">{{assignedUndertaking.name}}</span>
        </div>
        <modal ref="undertakingModal">
            <div slot="header" class="">
                <h3 class="pull-left" v-if="!createUndertakingDto">Assign An Undertaking</h3>
                <h3 class="pull-left" v-if="createUndertakingDto">Create New Undertaking</h3>
                <button class="btn pull-right" v-on:click="$refs['undertakingModal'].close()">X</button>
            </div>
            <div slot="body">
                <div class="" v-if="!createUndertakingDto">
                    <button class="btn btn-primary" v-on:click="createUndertaking">Create New Undertaking</button>
                    <hr />
                </div>
                <div class="" v-if="!createUndertakingDto">
                    <h4>Search Undertaking</h4>
                    <div class="">
                        <form @submit.prevent="loadData" class="form-horizontal">
                            <div class="form-group">
                                <div class="col-sm-2">
                                    <label for="searchDbNumber">DB Number</label>
                                </div>
                                <div class="col-sm-2">
                                    <input class="form-control" type="text" name="searchDbNumber" v-model="searchDto.dbNumber">
                                </div>
                                <div class="col-sm-2 col-sm-offset-1">
                                    <label for="searchName">Name</label>
                                </div>
                                <div class="col-sm-5">
                                    <input class="form-control" type="text" name="searchName" v-model="searchDto.name">
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="col-md-2">
                                    <label for="searchAgnecyNo">Agency Number</label>
                                </div>
                                <div class="col-md-4">
                                    <input class="form-control" type="text" name="searchAgnecyNo" v-model="searchDto.agencyNumber">
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="col-md-2">
                                    <button class="btn btn-primary" type="submit" name="button" v-on:click="loadUndertakingList()">Search</button>
                                </div>
                            </div>
                        </form>
                    </div>
                    <v-client-table :data="undertakingList" :columns="utGridSpec.columns" :options="utGridSpec.options">
                      <template slot="assign" slot-scope="props">
                        <div style="text-align: center;">
                            <button class="btn" v-on:click="assignUndertaking(props.row)">Assign</button>
                        </div>
                      </template>
                    </v-client-table>
                </div>
                <div class="" v-if="createUndertakingDto">
                    <form class="form form-horizontal" @submit.prevent data-vv-scope="undertakingDto">
                        <div class="form-group" v-bind:class="{ 'has-error': errors.has('undertakingDto.name') }">
                            <label class="col-xs-3 control-label">Undertaking Name</label>
                            <div class="col-xs-8">
                                <input class="form-control" type="text" name="name" v-model="createUndertakingDto.name" v-validate="'required'" aria-required="true" />
                                <span v-show="errors.has('undertakingDto.name')" class="has-error">Undertaking Name is required</span>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-xs-3 control-label">Agency Undertaking No</label>
                            <div class="col-xs-8">
                                <input class="form-control" type="text" name="agencyUndertakingNo" v-model="createUndertakingDto.agencyUndertakingNo" />
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-xs-3 control-label">Requirements</label>
                            <div class="col-xs-8">
                                <div class="checkbox checkbox-inline">
                                    <input id="reqMoaCheckbox" type="checkbox" name="reqMoa" v-model="createUndertakingDto.reqMoa">
                                        <label for="reqMoaCheckbox">MOA</label>
                                </div>
                                <div class="checkbox checkbox-inline">
                                    <input id="reqPaCheckbox" type="checkbox" name="reqPa" v-model="createUndertakingDto.reqPa">
                                        <label for="reqPaCheckbox">PA</label>
                                </div>
                                <div class="checkbox checkbox-inline">
                                    <input id="reqDiscoveryPlanCheckbox" type="checkbox" name="reqDiscoveryPlan" v-model="createUndertakingDto.reqDiscoveryPlan">
                                        <label for="reqDiscoveryPlanCheckbox">Discovery Plan</label>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-xs-3 control-label"></label>
                            <div class="col-xs-8">
                                <div class="checkbox checkbox-inline">
                                    <input id="reqDataDiscoveryPlanCheckbox" type="checkbox" name="reqDataDiscoveryPlan" v-model="createUndertakingDto.reqDataDiscoveryPlan">
                                        <label for="reqDataDiscoveryPlanCheckbox">Data Discovery Plan</label>
                                </div>
                                <div class="checkbox checkbox-inline">
                                    <input id="reqVisualContrastRatingCheckbox" type="checkbox" name="reqVisualContrastRating" v-model="createUndertakingDto.reqVisualContrastRating">
                                        <label for="reqVisualContrastRatingCheckbox">Visual Contrast Rating</label>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-xs-3 control-label"></label>
                            <div class="col-xs-8">
                                <div class="checkbox checkbox-inline">
                                    <input id="reqComplianceCheckCheckbox" type="checkbox" name="reqComplianceCheck" v-model="createUndertakingDto.reqComplianceCheck">
                                        <label for="reqComplianceCheckCheckbox">Compliance Check</label>
                                </div>
                                <div class="checkbox checkbox-inline">
                                    <input id="reqHabsHaerRecordCheckbox" type="checkbox" name="reqHabsHaerRecord" v-model="createUndertakingDto.reqHabsHaerRecord">
                                        <label for="reqHabsHaerRecordCheckbox">HABS/HAER Record</label>
                                </div>
                            </div>
                        </div>
                        <div class="form-group" v-bind:class="{ 'has-error': errors.has('undertakingDto.reviewFrameworkId') }">
                            <label class="col-xs-3 control-label">Review Framework</label>
                            <div class="col-xs-8">
                                <select name="reviewFrameworkId" class="form-control" v-model="createUndertakingDto.reviewFrameworkId" v-validate="'required'" aria-required="true">
                                    <option value="" disabled>Select a value</option>
                                    <option v-for="framework in reviewFrameworkList" v-bind:value="framework.id" :key="framework.id">
                                        {{ framework.description}}
                                    </option>
                                </select>
                                <span v-show="errors.has('undertakingDto.reviewFrameworkId')" class="has-error">Review framework is required</span>
                            </div>
                        </div>
                        <div class="form-group" v-bind:class="{ 'has-error': errors.has('undertakingDto.reviewTimeframeId') }">
                            <label class="col-xs-3 control-label">Review Timeframe</label>
                            <div class="col-xs-8">
                                <select name="reviewTimeframeId" class="form-control" v-model="createUndertakingDto.reviewTimeframeId" v-validate="'required'" aria-required="true">
                                    <option value="" disabled>Select a value</option>
                                    <option v-for="timeframe in reviewTimeframeList" v-bind:value="timeframe.id" :key="timeframe.id">
                                        {{ timeframe.description}}
                                    </option>
                                </select>
                                <span v-show="errors.has('undertakingDto.reviewTimeframeId')" class="has-error">Review timeframe is required</span>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-xs-3 control-label">Stipulations</label>
                            <div class="col-xs-8">
                                <textarea class="form-control" rows="7" name="stipulations" v-model="createUndertakingDto.stipulations"></textarea>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-xs-3 control-label">Comments</label>
                            <div class="col-xs-8">
                                <textarea class="form-control" rows="5" name="comments" v-model="createUndertakingDto.comment"></textarea>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div slot="footer">
                <div class="" v-if="createUndertakingDto">
                    <button class="btn btn-primary col-md-3" type="button" name="cancel" v-on:click="cancelCreate">Cancel</button>
                    <button class="btn btn-primary col-md-4 pull-right" type="button" name="submit" v-on:click="saveUndertaking">Create and Assign</button>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import undertakingService from '@/services/undertakingService'
import loggingService from '@/services/util/loggingService'
import investigationService from '@/services/investigationService'
import lookupService from '@/services/lookup/lookupService'

import modal from '../Modal.vue'

export default {
    name: 'undertakingModal',
    components: {
        modal
    },
    data: function () {
        return {
            isDebug: false,
            investigationId: this.$route.params.investigationId,
            undertakingList: [],
            reviewFrameworkList: undertakingService.ReviewFrameworkList,
            reviewTimeframeList: [],
            createUndertakingDto: null,
            assignedUndertaking: null,
            utGridSpec: {
                columns: ['assign', 'dbNumber', 'name', 'agencyDescription', 'agencyUndertakingNo', 'effect', 'createdDate'],
                tableData: [],
                options: {
                    dateFormat: 'YYYY-MM-DD',
                    perPage: 5,
                    perPageValues: [5, 10, 25, 50, 100],
                    dateColumns: ['createdDate'],
                    headings: {
                        dbNumber: 'DB Number',
                        name: 'Name',
                        agencyDescription: 'Agency',
                        agencyUndertakingNo: 'Agency No',
                        effect: 'Finding of Effect',
                        createdDate: 'Created Date'
                    },
                    orderBy: {
                        ascending: false,
                        column: 'createdDate'
                    }
                }
            },
            searchDto: {
                dbNumber: '',
                name: '',
                agencyNumber: ''
            }
        }
    },
    mounted () {
        loggingService.log(this.isDebug, this.componentName + ' - mounted')
        this.loadReviewTimeframeList()
        this.loadUndertakingList().then(response => {
            loggingService.log(this.isDebug, 'UndertakingModal', 'loadUndertakingList')
        })
    },
    computed: {
        investigationName: function () {
            if (this.$parent.$parent.$parent.investigation) {
                return this.$parent.$parent.$parent.investigation.reportTitle
            } else {
                return ''
            }
        }
    },
    methods: {
        loadUndertakingList () {
            this.undertakingList = []
            return undertakingService.searchInProgress(this.$http, this.searchDto).then(response => {
                this.undertakingList = response.data
                loggingService.log(this.isDebug, 'UndertakingModal', 'undertaking list count' + this.undertakingList.length)
            })
        },
        loadReviewTimeframeList () {
            return lookupService.listLookup(this.$http, 'ReviewTimeframe').then(response => {
                this.reviewTimeframeList = response.data
                return response
            })
        },
        createUndertaking () {
            this.createUndertakingDto = {
                name: this.investigationName,
                agencyUndertakingNo: '',
                reqMoa: false,
                reqPa: false,
                reqDiscoveryPlan: false,
                reqDataDiscoveryPlan: false,
                reqVisualContrastRating: false,
                reqComplianceCheck: false,
                reqHabsHaerRecord: false,
                reviewFrameworkId: '',
                reviewTimeframeId: '',
                stipulations: '',
                comment: ''
            }
        },
        cancelCreate () {
            this.createUndertakingDto = null
        },
        saveUndertaking () {
            this.$validator.validateAll('undertakingDto').then(result => {
                if (result) {
                    // save the new undertaking
                    undertakingService.put(this.$http, this.createUndertakingDto).then(response1 => {
                        loggingService.log(this.isDebug, 'UndertakingModal', 'new undertaking saved')
                        // clear the dto
                        this.createUndertakingDto = null
                        // assign the newly created undertaking to the investigation
                        if (response1.data.objectList && response1.data.objectList.length > 0) {
                            this.assignUndertaking(response1.data.objectList[0])
                        } else {
                            loggingService.log(this.isDebug, 'New undertaking not found, cannot assign to Investigation')
                        }
                        // reload the undertaking list
                        this.loadUndertakingList()
                    })
                } else {
                    loggingService.log(this.isDebug, 'UndertakingModal', 'submit - invalid form')
                }
            })
        },
        assignUndertaking (undertaking) {
            // set the assigned undertaking
            this.assignedUndertaking = undertaking
            // if this is not in Investigation, return
            if (!this.investigationId) return
            // create the setUndertaking object
            var investigationSetUndertaking = {
                investigationId: this.investigationId,
                undertakingId: undertaking.undertakingId,
                setPrimaryOnly: true
            }
            // update investigation with the setUndertaking object
            investigationService.setUndertaking(this.$http, investigationSetUndertaking).then(response => {
                this.$refs['undertakingModal'].close()
                //set the new undertakingId and undertakingName to the SiteSummary investigation data object
                this.$parent.$parent.$parent.investigation.undertakingId = undertaking.undertakingId
                this.$parent.$parent.$parent.investigation.undertakingName = undertaking.name
            })
        }
    }

}
</script>

<style>
</style>



// WEBPACK FOOTER //
// UndertakingModal.vue?7636c5a6